// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { type ReferralBankDetails } from '../../../utilities/types';
import {
  loadReferralBankDetails,
  setFormState,
  setFileUploadDirty
} from './reducer';
import BankAccountForm from './BankAccountForm';
import SectionLoader from '../../../components/SectionLoader';
import { getFiatCurrencies } from '../../../utilities/selectors';
import { type Currency } from '../../../utilities/types';

type Props = {
  loading: boolean,
  initialValues: $Exact<ReferralBankDetails>,
  formState: string,
  loadReferralBankDetails: () => void,
  setFormState: string => void,
  voidedCheque: string,
  fileUploadDirty: boolean,
  setFileUploadDirty: boolean => void,
  fiatCurrencies: Currency[]
};

class BankAccount extends Component<Props> {
  componentDidMount() {
    this.props.loadReferralBankDetails();
  }
  componentWillUnmount() {
    this.props.setFileUploadDirty(false);
    if (this.props.formState === 'edit') {
      this.props.setFormState('show');
    }
  }

  render() {
    if (this.props.loading) {
      return <SectionLoader />;
    }

    return (
      <BankAccountForm
        initialValues={this.props.initialValues}
        loading={this.props.loading}
        formState={this.props.formState}
        loadReferralBankDetails={this.props.loadReferralBankDetails}
        setFormState={this.props.setFormState}
        voidedCheque={this.props.voidedCheque}
        setFileUploadDirty={this.props.setFileUploadDirty}
        fileUploadDirty={this.props.fileUploadDirty}
        fiatCurrencies={this.props.fiatCurrencies}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.account.bankAccount.loading,
  initialValues: state.account.bankAccount.referralBankDetails,
  voidedCheque: state.account.bankAccount.referralBankDetails.voided_cheque,
  formState: state.account.bankAccount.formState,
  fileUploadDirty: state.account.bankAccount.fileUploadDirty,
  fiatCurrencies: getFiatCurrencies(state)
});

const mapDispatchToProps = {
  setFileUploadDirty,
  loadReferralBankDetails,
  setFormState
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankAccount);
